import styled, { css } from 'styled-components';
import { ifProp, prop } from 'styled-tools';

export const Empty = styled.div<{ hideImage?: boolean; isPrivate?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding: var(--layout-03) var(--spacing-06) var(--layout-03) var(--spacing-05);
  background-color: ${(props) =>
    props.isPrivate ? 'var(--private-02)' : 'var(--coolest-gray-10)'};

  ${ifProp(
    prop('hideImage', false),
    css`
      justify-content: center;
      & > svg {
        display: none;
      }
    `,
  )};
`;
